<template>
  <escalon-dialog
    :showModal="showModal"
    @close="logout"
    @modalConfirm="confirm"
    @modalCancel="logout" >
    <template slot="header">You have been idle</template>
    Do you want to remain logged in?
    <br/>
    Time remaining until logout: {{timeUntilLogout}}
  </escalon-dialog>
</template>

<script>
import escalonDialog from "./EscalonDialog";
import { setupRefreshPatientLoop } from "../../../src/helpers/patientRefresh";
export default {
  name: "AutoLogoutModal",
  components: {
    escalonDialog
  },
  data() {
    return {
      remaining: 0,
      remainingIntervalId: 0,
      timeout: 300000, // 5 minutes
    }
  },
  computed: {
    showModal() { 
      console.log("show autologout modal");
      return this.$store.getters.isIdle && !this.$store.getters.disableAutoLogout 
    },
    timeUntilLogout() {
      return new Date(this.remaining * 1000).toISOString().substring(14, 19);
    }
  },
  methods: {
    confirm() {
      if (this.remainingIntervalId) window.clearInterval(this.remainingIntervalId);
      this.$store.commit("goActive");
      setupRefreshPatientLoop();
    },
    logout: function() {
      if (this.remainingIntervalId) window.clearInterval(this.remainingIntervalId);
      // going "active" here to make sure the modal closes before logging out
      this.$store.commit("goActive");
      this.$nextTick()
        .then(() => this.$store.dispatch("logout"))
        .then(() => this.$router.push("/"));
    },
    startAutoLogout(){
      var end = Date.now() + this.timeout;
      this.remainingIntervalId = window.setInterval(() => {
        this.remaining = Math.floor((end - Date.now()) / 1000); 
        if(this.remaining < 0) { 
          window.clearInterval(this.remainingIntervalId); 
          this.logout();
          return;
        }
      },200);     
    },
  },
  watch: {
    showModal(){
      if (this.showModal) this.startAutoLogout();
      else {
        if (this.remainingIntervalId) window.clearInterval(this.remainingIntervalId);
      }
    }
  }
}
</script>
